import {equipmentOidTypes} from '@/components/mixins/ConversionMixin'

export default class VelhoBoomsBarriersBollardsModel {
    // Private properties
    /** @type {string} */
    _external_system_id = equipmentOidTypes.EXTERNAL_BOOM_BARRIER_BOLLARD

    constructor(
        type = null, material = null, position = { x: null, y: null }, roadNum = null, roadSec = null, distance = null, condition = null, refinedType = null, technique = null, controlType = null, length = null,
        railwayLevelCrossingBoomAdditionalType = null, code = "", productName = "", equipmentDamages = [], locationDeviation = null,
        locationSpecification = { lane: [], side: null, tracks: null, central_area: null }, externalSystemId = ""
    ) {
        /** @type {number | null} */
        this.type = type

        /** @type {number | null} */
        this.material = material

        /** @type {{ x: number, y: number }} */
        this.position = position

        /** @type {number | null} */
        this.road_num = roadNum

        /** @type {number | null} */
        this.road_sec = roadSec

        /** @type {number | null} */
        this.distance = distance

        /** @type {number | null} */
        this.condition = condition

        /** @type {number | null} */
        this.refined_type = refinedType

        /** @type {number | null} */
        this.technique = technique

        /** @type {number | null} */
        this.control_type = controlType

        /** @type {number | null} */
        this.length = length

        /** @type {number | null} */
        this.railway_level_crossing_boom_additional_type = railwayLevelCrossingBoomAdditionalType

        /** @type {string} */
        this.code = code

        /** @type {string} */
        this.product_name = productName

        /** @type {Array} */
        this.equipment_damages = equipmentDamages

        /** @type {number | null} */
        this.location_deviation = locationDeviation

        /** @type {{ lane: number[], side: number | null, tracks: number | null, central_area: number | null }} */
        this.location_specification = locationSpecification

        if(externalSystemId) {
            this._external_system_id = externalSystemId
        }
    }

    /**
    * Gets the unique identifier.
    * @returns {string}
    */
    get external_system_id() {
        return this._external_system_id
    }

    /**
    * Get the culvert json object.
    * @returns {object}
    */
    toJSON() {
        return JSON.parse(
            JSON.stringify({
            external_system_id: this._external_system_id,
            type: this.type,
            material: this.material,
            position: this.position,
            road_num: this.road_num,
            road_sec: this.road_sec,
            distance: this.distance,
            condition: this.condition,
            refined_type: this.refined_type,
            technique: this.technique,
            control_type: this.control_type,
            length: this.length,
            railway_level_crossing_boom_additional_type: this.railway_level_crossing_boom_additional_type,
            code: this.code,
            product_name: this.product_name,
            equipment_damages: this.equipment_damages,
            location_deviation: this.location_deviation,
            location_specification: {
                ...this.location_specification,
                tracks: this.location_specification.tracks !== null ? [this.location_specification.tracks] : []
            }
        }))
    }

    /**
    * Create default instance with position data.
    * @param {{ x: number, y: number }} position - coordinates.
    * @param {number | null} roadNum - Road number.
    * @param {number | null} roadSec - road section.
    * @param {number | null} distance - distance (road geometry).
    * @returns {VelhoBoomsBarriersBollardsModel}
    */
    static instanceWithPosition(position, roadNum, roadSec, distance) {
        const instance = new VelhoBoomsBarriersBollardsModel()
        instance.position = position
        instance.road_num = roadNum
        instance.road_sec = roadSec
        instance.distance = distance
        return instance
    }
}
